export default __webpack_public_path__ + "static/media/Adirek_Sans_ExtraBold_Italic.f137ff38.otf";